export enum FILE_PICKER {
    /**
     * @value Last created
     */
    LAST_CREATED = 'WALL_ORDER_BY_CREATED',
    /**
     * @value Select a file
     */
    SELECT_FILE = 'WIDGET_TYPE_DRIVE-FILE-PREVIEW_SELECT_FILE',
    /**
     * @value Select PDF
     */
    SELECT_PDF = 'WIDGET_PDF_PREVIEW.SELECT_PDF',
}
